import React from "react";
import Modal from "../Modal/Modal";
import Button from "../../Button/Button";
import { formatPrice } from "../../../../utils/utils";
import styles from "./ConversionModal.module.scss";

const ConversionModal = ({
  show,
  handleClose,
  quantity,
  firstToken,
  secondToken,
  spotPrice,
  cryptoPrices,
  convertTokens,
  approxTokens,
}) => {
  const getPrice = (token) => {
    switch (token.value) {
      case 1:
        return spotPrice?.goldPrice;
      case 2:
        return spotPrice?.silverPrice;
      case 3:
        return cryptoPrices?.ethPrice;
      case 4:
        return cryptoPrices?.btcPrice;
      default:
        return 0;
    }
  };

  return (
    <Modal
      className={styles.conversion_modal}
      show={show}
      handleClose={handleClose}
      title={`Convert ${firstToken.label} to ${secondToken.label}`}
    >
      <ul>
        <li>
          <h6>Pay with</h6>
          <h4>
            <img
              className={styles.tokenImgMargin}
              src={firstToken.icon}
              alt={`${firstToken.label}-icon`}
            />
            {quantity} {firstToken.label}
          </h4>
        </li>
        <li>
          <h6>{firstToken.label} Price</h6>
          <h4>$ {getPrice(firstToken)}</h4>
        </li>
        <li>
          <h6>{secondToken.label} Price</h6>
          <h4>$ {getPrice(secondToken)}</h4>
        </li>
        <li>
          <h6>Total</h6>
          <h4>
            <img
              className={styles.tokenImgMargin}
              src={firstToken.icon}
              alt={`${firstToken.label}-icon`}
            />
            {quantity} ≈{" "}
            <img
              className={styles.tokenImgMargin}
              src={secondToken.icon}
              alt={`${secondToken.label}-icon`}
            />{" "}
            {formatPrice(Number(approxTokens))}
          </h4>
        </li>
        <li>
          <p>
            Disclaimer: Final price may vary due to fluctuating Spot prices of
            selected tokens.
          </p>
        </li>
      </ul>
      <Button
        fluid
        onClick={() => {
          convertTokens();
        }}
        className={styles.submit_btn}
      >
        Confirm Convert
      </Button>
    </Modal>
  );
};

export default ConversionModal;
